import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  IconButton,
} from "@mui/material";
import { isValidInput } from "../../utils/validations";
import {
  useLazyDeleteMyNotificationQuery,
  useLazyGetNotificationsQuery,
} from "../../service/notification";
import { showError, showToast } from "../../constants/toasts";
import { NotificationType } from "../../types/General";
import dayjs from "dayjs";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import CustomPagination from "../../components/CustomPagination";
import { NOTIFICATION_TYPE } from "../../utils/enums";

const RecievedNotifications = () => {
  const navigate = useNavigate();
  const [getNotifications] = useLazyGetNotificationsQuery();
  const [deleteNotification] = useLazyDeleteMyNotificationQuery();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(10);
  const [openDelete, setOpenDelete] = useState(false);
  const [notificationData, setNotificationData] = useState<NotificationType[]>(
    []
  );
  const [selectedId, setSelectedId] = useState("");

  const deleteNotificationApi = async (id: string) => {
    try {
      const response = await deleteNotification({
        id,
      }).unwrap();

      if (response.status === 200) {
        showToast(response?.message || "");
        getNotificationApi();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getNotificationApi = async () => {
    setLoading(true);
    try {
      const response = await getNotifications({
        search: debouncedSearchTerm.trim(),
        page,
      }).unwrap();
      setLoading(false);
      setHasFetched(true);
      if (response.status === 200) {
        setNotificationData(response?.data?.items || []);
        setCount(response?.data?.totalCount);
      } else {
        setNotificationData([]);
      }
    } catch (error: any) {
      setHasFetched(true);
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getNotificationApi();
  }, [page, debouncedSearchTerm]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Recieved Notifications</h1>
        <p>
          <span
            role="button"
            tabIndex={0}
            onClick={() => navigate("/dashboard")}
          >
            Dashboard
          </span>
          - Recieved Notifications
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </div>
        </div>
        <TableContainer className="table_container">
          <Box className="heading"></Box>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>

                <TableCell>Title</TableCell>
                <TableCell>Message</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notificationData?.length ? (
                notificationData?.map((row, i) => {
                  return (
                    <TableRow
                      className="cursor_p"
                      onClick={() => {
                        if (
                          row?.notificationType === NOTIFICATION_TYPE.BOOKING
                        ) {
                          navigate(`/manage-booking-resvp`);
                        } else if (
                          row?.notificationType === NOTIFICATION_TYPE.PAYMENT
                        ) {
                          navigate(`/transactions`);
                        } else if (
                          row?.notificationType === NOTIFICATION_TYPE.ACCOUNT
                        ) {
                          navigate(`/manage-customers`);
                        }
                      }}
                    >
                      <TableCell>{(page - 1) * 10 + i + 1}</TableCell>

                      <TableCell>{row?.title || "-"}</TableCell>
                      <TableCell className="max_c">
                        <p>{row?.body || "-"}</p>
                      </TableCell>
                      <TableCell>
                        {row?.createdAt
                          ? dayjs(row?.createdAt).format("DD MMM YYYY")
                          : "-"}
                      </TableCell>
                      <TableCell>
                        <Box>
                          <IconButton
                            onClick={() => {
                              setOpenDelete(true);
                              setSelectedId(row?.id);
                            }}
                          >
                            <img
                              src="/static/images/trash_icon.svg"
                              alt="Icon"
                            />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : hasFetched ? (
                <tr>
                  <td
                    colSpan={5}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No Data Found
                  </td>
                </tr>
              ) : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {notificationData?.length ? (
        <CustomPagination
          currentPage={page - 1}
          totalPages={Math.ceil(count / 10)}
          count={count}
          pageSize={10}
          onPageChange={(page) => setPage(page + 1)}
        />
      ) : null}
      <ConfirmationModal
        text={"Are you sure to delete this Notification ?"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={() => deleteNotificationApi(selectedId)}
      />
    </MainContainer>
  );
};

export default RecievedNotifications;
